import React from 'react';
import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';

function DeleteModal({
	isDeleteBulkConfirmationModalOpen,
	setIsDeleteBulkConfirmationModalOpen,
	selectedListForDelete,
	deleteLength,
	handleBulkDelete,
	saleTypeName,
}) {
	return (
		<Modal
			className="deleteVendorsModal"
			title={`Delete ${saleTypeName}`}
			isOpen={isDeleteBulkConfirmationModalOpen}
			onClose={() => {
				setIsDeleteBulkConfirmationModalOpen(false);
			}}
			cancelButton={() => {
				setIsDeleteBulkConfirmationModalOpen(false);
			}}
		>
			<p
				style={{
					textAlign: 'center',
					backgroundColor: '#E6F5FF',
					padding: '10px',
					borderRadius: '5px',
					fontWeight: '600',
					color: 'black',
				}}
			>
				Are you sure you want to delete {deleteLength} {saleTypeName}?
			</p>
			<div
				style={{
					padding: '0px 10px',
				}}
			>
				{selectedListForDelete?.length > 0 &&
					selectedListForDelete?.map((name, index) => (
						<p
							style={{
								fontSize: '13px',
								fontWeight: '500',
							}}
							key={name + index}
						>
							{index + 1}. {name}
						</p>
					))}
			</div>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					justifyContent: 'end',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-gray add-pro"
					button="Cancel"
					onClick={() => {
						setIsDeleteBulkConfirmationModalOpen(false);
					}}
				/>

				<Button
					type="button"
					button="Confirm"
					className="mt-0 px-4 btn-danger relative"
					onClick={handleBulkDelete}
				/>
			</div>
		</Modal>
	);
}

export default DeleteModal;
